var formValidation = require('base/components/formValidation');
var otpFunctions = require('../otpfunctions');
var abd;

function toggleDisabledPaymentTabs() {
    var isAddressIncomplete = $('.migratedUserAddressNotUpdated').length > 0;
    $('.payment-form .credit-card-selection-new .tab-content').toggleClass('disabled', isAddressIncomplete);
    $('.payment-form .credit-card-selection-new .tab-content .submit-payment, .submit-cod-payment').toggleClass('disabled', isAddressIncomplete);
}
toggleDisabledPaymentTabs();
$('body').on('shipping:addressBecameComplete', toggleDisabledPaymentTabs);
// Pay by Razorpay method
$(document).on('click', '#razorPayPlaceOrder', function (e) {
    e.preventDefault();
    var inputField = $('#razorpayUrl');
    let positveBtn = $('#positiveBtn');
    var serviceError = $('#serviceError');
    let xsdData;
    var url = inputField.val();
    $.ajax({
        url,
        type: 'get',
        success(data) {
            var jsonString = JSON.stringify(data);

            // Set the JSON string as a data attribute in the HTML element
            $('#Razorpay-json-container').data('json', jsonString);
            xsdData = data;
            if(data.error && data.redirectUrl) {
                window.location.href = data.redirectUrl;
            }
            if(!data.order_id) {
                serviceError.removeClass('d-none').addClass('d-flex');
                $("html, body").animate({ scrollTop: 0 }, "slow");
            } else {
                $('#razorpay-payment-button').click();
            }
            if ($('.modal-close').length > 0) {
                console.log('payment failed by cliehnt');
            }
        },
        error() {
            console.error(error);
        },
    });
});




$(document).on('show.bs.tab', '.paypal-tab, .js-paypal-tab', function () {
    if ($('.paypalServiceStatus').val() === "true") {
        $('#paypalPlaceOrder').addClass('serviceUnavailable');
    }
});

$(document).on('show.bs.tab', '.payment-information .payment-options .nav-link', function () {
    var isPaypalTab = $(this).hasClass('paypal-tab') || $(this).hasClass('js-paypal-tab');

    if (!isPaypalTab) {
        $('#paypalPaymentError').addClass('d-none').removeClass('d-flex');
        $('#paypalServiceError').addClass('d-none').removeClass('d-flex');
    }
});

$(document).on('click', '#paypalPlaceOrder.serviceUnavailable', function () {
    $('#paypalServiceError').removeClass('d-none').addClass('d-flex');
    $("html, body").animate({ scrollTop: 0 }, "slow");
});

// Pay by PayU method

const payuUrlElement = $('#payUUrl');
const payuUrl = payuUrlElement.val();

$(document).on('click', '#payUCreate', function (e) {
    e.preventDefault();
    var url = payuUrl;
    $.ajax({
        url,
        type: 'get',
        success(data) {
            if(data.error && data.redirectUrl) {
                window.location.href = data.redirectUrl;
                return;
            }
            $('#payUContent').empty();
            $('#payUContent').append(data);
            $('#PayUForm').submit();
        },
        error() {
            console.error('Error fetching content:', error);
        },
    });
    $('#PayUForm').submit();
});

$(document).on('show.bs.tab', '.cod-tab', function () {
    if ($('.submit-cod-payment-otp').length) {
        var userMobile = $.trim($('.shipping-phone:first').text());
        var codPaymentButton = $('.cod-content .submit-cod-payment-otp')
        var url = codPaymentButton.attr('href').split('?')[0];
        codPaymentButton.attr('href', `${url}?phone=${userMobile}`);
    }
});

$(document).on('click', '.cod-content .submit-cod-payment-otp', function (e) {
    e.preventDefault();
    var codPayButton = $(this);
    var url = codPayButton.attr('href');
    $.spinner().start();
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        success: function (data) {
            if (!data.success) {
                formValidation(form, data);
            } else {
                $.spinner().stop();
                var phoneNumber = data.queryString.split("=").pop();
                $('#verifyOTPcod').modal('show');
                $('.resendCounter').css('display', 'block');
                $('.resendButton').css('display', 'none');
                if ($('.registration-id').length) {
                    $('.registration-id').text("+91 "+phoneNumber);
                }
                otpFunctions.timerEvent();
                otpFunctions.otpInputs();
                otpFunctions.handleAutoFillOTP();
            }
        },
        error: function () {
            $.spinner().stop();
        }
    });
    return false;
});

$('#verifyOTPcod').on('hidden.bs.modal', function () {
    clearInterval(window.downloadTimer);
    $('.resendCounter').html('').css('display', 'none');
    $('.resendButton').css('display', 'block');
});

$(document).on('submit', '#verify-codotp-form', function (e) {
    e.preventDefault();
    var form = $(this);
    var url = form.attr('action');
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        success: function (data) {
            if (!data.success) {
                formValidation(form, data);
            } else {
                window.location.href = $('.codCreateUrl').val();
            }
        },
        error: function () {
            //form.spinner().stop();
        }
    });
    return false;
});

var paymentButton = $(document).find('.payment-information .payment-options .nav-item .nav-link').length;
if (paymentButton >= 2) {
    $('.payment-information .payment-options .nav-item .nav-link').first().trigger('click');
} else if (paymentButton === 1) {
    $(document).find('.payment-methods').hide();
    $('.payment-information .payment-options .nav-item .nav-link').first().trigger('click');
}

$(document).on('click', '.payment-form-fields a', function (e) {
    var currentPaymentMethod = $('.payment-information .nav-link.active').closest('.nav-item').data('method-id');
    var dataForGAPayment = JSON.parse(dataForGAPaymentInfo);
    dataForGAPayment.eventAction = currentPaymentMethod;
    dataForGAPayment.ecommerce.payment_type = currentPaymentMethod;
    window.dataLayer.push(dataForGAPayment);
});

$(document).on('click', '.checkout-login-cta-link' ,function () {
    sessionStorage.setItem('movingToCheckout', true);
});



// Event listener for input focus out
$(document).on("blur","#guest-email", function(e) {
    e.preventDefault();
    var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    var email = $(this).val().trim();
    var form = $(this).closest('form');

    if (emailRegex.test(email)) {
        form.find('.invalid-feedback').hide();
        form.find('.existing-user-msg').hide();
        $('.submit-shipping').removeClass('disabled');
        $.ajax({
            type: "POST",
            url: form.attr('action'),
            data: { customerEmail: email },
            success: function(response) {
                if(response.success){
                    form.find('.invalid-feedback').hide();
                } else {
                    form.find('.existing-user-msg').text(response.message).show();
                }
            },
            error: function(xhr, status, error) {
                console.error("AJAX error:", status, error);
            }
        });
    } else {
        form.find('.invalid-feedback').show();
    }
});
// Event listener for triggering the blur event for form submition
$(document).on("submit","#guest-email-form", function(e) {
    e.preventDefault();
    $(this).find('#guest-email').trigger('blur');
});
